import { RetestResultStatusEnum } from '../_enums';

export const retestResultStatusNames: Record<RetestResultStatusEnum, string> = {
    [RetestResultStatusEnum.NO]: 'order.results.retestedStatus.No',
    [RetestResultStatusEnum.REQUESTED]: 'order.results.retestedStatus.Requested',
    [RetestResultStatusEnum.YES]: 'order.results.retestedStatus.Yes',
};
